/**
 * noty
 */

import $ from 'jquery';
import Page from 'js/lib/page';

export default class Noty extends Page {
  init() {
    this.elements({
      button: '.js-noty-button'
    });

    this.param = {
      timer: localStorage.getItem('notyTimer'),
      LIVING_TIME: 24 * 60 * 60 * 30 // 30 days
    };

    if (this.getState()) {
      this.toggle();
    }

    this.events();
  }
  events() {
    this.$.button.on('click', () => this.handler());
  }
  getState() {
    return this.param.timer == null || this.timeExpired();
  }
  getTime() {
    return Math.round(new Date().getTime() / 1000);
  }
  timeExpired() {
    const timer = Number(this.param.timer);
    const livingTime = this.param.LIVING_TIME;

    return this.getTime() > timer + livingTime;
  }
  handler() {
    localStorage.setItem('notyTimer', this.getTime().toString());
    this.toggle();
  }
  toggle() {
    this.$.root.toggleClass('is-hide');
  }
}

Page.make(Noty, '.js-noty');
